export const FONT_FAMILY_TOOL_OPTIONS = [
  { id: 1, label: 'Sans Serif', value: 'sans' },
  { id: 2, label: 'Serif', value: 'serif' },
  { id: 3, label: 'MonoSpace', value: 'monospace' },
];
